import React from 'react';
import classNames from 'classnames';
import CountdownTimer from '../../CountdownTimer';
import './TimerSection.scss';

export default function TimerSection({timerHeading, launchEnd, ...props}) {
  return (
    <div className={classNames(`section-countdown text-white`, props.className)}>
      <h4 className={classNames(`timer-heading mx-auto mt-4 mb-2`, props.timerHeadingClass)}>{timerHeading}</h4>
      <CountdownTimer time={launchEnd} />
    </div>
  );
}
